import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/opt/project/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/opt/project/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/app/hazassagkoto-terem/[news_id]/page.module.css");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/png/empty-event-logo.png");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/_dot.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/arrow-up-right.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/chevron-right.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/home.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/icons/loader.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/assets/svg/ideas_background.svg");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/common/buttons/button.module.css");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/common/safe_image/safe_image.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/home_page/wedding_locations/wedding_locations_section.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/components/idea/idea_read_tracker.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/idea/idea.module.css");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/ideas/ideas.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/project/src/components/link_with_params/link_with_params.js");
;
import(/* webpackMode: "eager" */ "/opt/project/src/components/wedding_venues/wedding_venues.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["clearBackendTokenFromSecureStorage"] */ "/opt/project/src/utils/mobile-secure-token.js");
